import lightBaseTheme from "material-ui/styles/baseThemes/lightBaseTheme";

export default {
  ...lightBaseTheme,
  palette: {
    ...lightBaseTheme.palette,
    primary1Color: "#69b628",
    accent1Color: "#dd2a2b"
  },
  radioButton: {
    checkedColor: "#5e80bd"
  },
  checkbox: {
    checkedColor: "#5e80bd"
  }
};



// WEBPACK FOOTER //
// ./src/theme.js